import { action, makeObservable, observable } from 'mobx'

import { getEmployee_employee_organisation_portalContent } from 'Constants/graphql/queries/employee/__generated__/getEmployee'
import { getOrganisation_organisation_portalContent } from 'Constants/graphql/queries/organisation/__generated__/getOrganisation'

export class PortalContentStore {
  portalContent:
    | getOrganisation_organisation_portalContent
    | getEmployee_employee_organisation_portalContent
    | null = null

  constructor() {
    makeObservable(this, {
      portalContent: observable,
      setPortalContent: action,
    })
  }

  setPortalContent = (
    content:
      | getOrganisation_organisation_portalContent
      | getEmployee_employee_organisation_portalContent
      | null,
  ) => {
    this.portalContent = content
  }
}
